import lambdaApi from 'api/LambdaApi';
import { AxiosError } from 'axios';
import {
    IntegrationOwnerList,
    IntegrationOwnerModel,
    IntegrationOwnerRequestPayload,
} from 'generated-types/integration_owner';
import { useMutation, useQuery } from 'react-query';

type Props = {
    name: string;
    integration_owner_id: number;
};

export function useIntegrationOwners(props?: Props) {
    const { data, isLoading, isSuccess, isError, refetch } = useQuery<IntegrationOwnerList>(
        ['integrationOwners'],
        () => lambdaApi.get('/integration-owner', {}).then(res => res.data),
    );

    const createIntegrationOwner = useMutation<
        IntegrationOwnerModel,
        AxiosError,
        IntegrationOwnerRequestPayload
    >(payload => {
        return lambdaApi.post('/integration-owner', payload).then(res => res.data);
    });

    const updateIntegrationOwner = useMutation<
        IntegrationOwnerModel,
        AxiosError,
        IntegrationOwnerModel
    >(payload => {
        return lambdaApi.put(`/integration-owner/${payload.id}`, payload).then(res => res.data);
    });

    const deleteIntegrationOwner = useMutation<null, AxiosError, number>(id => {
        return lambdaApi.delete(`/integration-owner/${id}`).then(res => res.data);
    });

    return {
        createIntegrationOwner,
        integrationOwners: data,
        updateIntegrationOwner,
        deleteIntegrationOwner,
        isLoading,
        isSuccess,
        isError,
        refetch,
    };
}
